<footer id="app-footer" class='mi-footer'>
  <div class="text-center small mt-2">
    <a class="mr-2 " href="https://www.zopper.com/" target="_blank">Powered by
      <img (load)="offsetFooter()" class="zop-logo" alt="Zopper"
           src="../../assets/images/logo.svg"></a>
  </div>
</footer>
